import React from 'react'
import Item from './item'
interface ICashinCashoutProps {
    data: ICashinCashoutFinancial[]
}
export default function CashinCashout({ data }: ICashinCashoutProps) {
    return (
        <div>
            {data.map((item) => (
                <Item key={item.id} item={item} />
            ))}
        </div>
    )
}
